export default __webpack_public_path__ + "static/media/main_icon.880142c0.png";